let enable_nlx_chat = 'nlx' === 'nlx';
let nlx_bot_url = 'https://bots.studio.nlx.ai/c/IyBTL66SHNGLyFBsPbFJu/Jg-DfP7hHNGpqkHyLYpHD'
let nlx_api_key = 'JeDP3LuUyOb=aE6A4H1U-Wpz0_OtcBVN'
let nlx_locales = '["en-US", "es-ES", "fr-FR", "de-DE", "pt-PT", "it-IT", "ro-RO", "nl-NL", "ko-KR", "pl-PL"]'

const DV_INFO_STORAGE_KEY = 'esimShopifyDVInfo';
const DV_INFO_TIMESTAMP_KEY = 'esimShopifyDVInfoTs';
// Re-check periodically so devices DeviceAtlas couldn't fully identify yet (e.g. newly released models) get refreshed
const DV_INFO_MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;

// 'idle' | 'loading' | 'done' | 'error'
let deviceAssureStatus = 'idle';

function maybeInitNLX() {
  if (enable_nlx_chat && nlx_bot_url && nlx_api_key && nlx_locales && isInitNLX == false) {
    initNLX();
  }
}

function hasDeviceAtlasProperties(info) {
  return !!(info && info.deviceAtlasProperties && Object.keys(info.deviceAtlasProperties).length > 0);
}

// Fired on window as 'deviceassure:result' (detail: deviceInfo) or 'deviceassure:error'
function dispatchDeviceAssureEvent(name, detail) {
  window.dispatchEvent(new CustomEvent(`deviceassure:${name}`, { detail: detail }));
}

function isIOSDevice(userAgent) {
  if (/iPad|iPhone|iPod/.test(userAgent)) return true;
  // iPadOS 13+ Safari reports a desktop Mac user agent by default
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
}

function deviceAssurePlatformCheck() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    maybeInitNLX();
    return false;
  }

  if (/android/i.test(userAgent) || isIOSDevice(userAgent)) {
    return true;
  }

  maybeInitNLX();
  return false;
}

function getCachedDeviceInfo() {
  try {
    let deviceInfoStr = localStorage.getItem(DV_INFO_STORAGE_KEY);
    if (!deviceInfoStr) return null;

    let storedAt = parseInt(localStorage.getItem(DV_INFO_TIMESTAMP_KEY), 10);
    let cached = JSON.parse(deviceInfoStr);
    // Entries written before the timestamp existed have no storedAt - treat them as expired
    if (!storedAt || Date.now() - storedAt > DV_INFO_MAX_AGE_MS || !hasDeviceAtlasProperties(cached)) {
      throw new Error('Stale device info');
    }
    return cached;
  } catch (error) {
    try {
      localStorage.removeItem(DV_INFO_STORAGE_KEY);
      localStorage.removeItem(DV_INFO_TIMESTAMP_KEY);
    } catch (e) {}
    return null;
  }
}

function shouldRunDeviceAssure() {
  let cached = getCachedDeviceInfo();
  if (cached) {
    deviceInfo = cached;
    deviceAssureStatus = 'done';
    maybeInitNLX();
    return false;
  }

  return deviceAssurePlatformCheck();
}

function loadDeviceAssure() {
  // Several templates call this on the same page - only hit the API once
  if (deviceAssureStatus === 'loading' || deviceAssureStatus === 'done') return;

  const onError = (error) => {
    deviceAssureStatus = 'error';
    dispatchDeviceAssureEvent('error', error);
  };

  if (!window.DeviceAssure || typeof window.DeviceAssure.load !== 'function') {
    // Library failed to load (e.g. blocked by a content blocker)
    onError(new Error('DeviceAssure library not available'));
    return;
  }

  deviceAssureStatus = 'loading';

  const onSuccess = (response) => {
    let deviceInfoObj = null;
    try {
      deviceInfoObj = response && response.response != null ? JSON.parse(response.response) : null;
    } catch (exception) {}

    if (!hasDeviceAtlasProperties(deviceInfoObj)) {
      onError(new Error('DeviceAssure returned no device properties'));
      return;
    }

    try {
      localStorage.setItem(DV_INFO_STORAGE_KEY, response.response);
      localStorage.setItem(DV_INFO_TIMESTAMP_KEY, String(Date.now()));
    } catch (e) {}

    deviceInfo = deviceInfoObj;
    deviceAssureStatus = 'done';
    maybeInitNLX();
    dispatchDeviceAssureEvent('result', deviceInfo);
  };

  // We cache the parsed result ourselves, so disable the library's own 30 minute cache
  window.DeviceAssure.load({
    licence: '21f2ca8d1c592e56d67ebf617b68658e',
    storageType: 'none',
    onSuccess: onSuccess,
    onError: onError,
  });
}

function getDeviceCompatability(deviceInfo) {
  const strings = window.deviceInfoStrings || {};
  const properties = (deviceInfo && deviceInfo.deviceAtlasProperties) || {};
  const fullName = properties.standardisedFullName || '';
  const eSimCount = properties.eSimCount;
  const eSimCountUnknown = eSimCount === undefined || eSimCount === null;

  let device = fullName;
  let compatible = false;
  let message = '';

  // DeviceAtlas can't identify the exact model, only that it's an iPhone
  if (fullName == 'Apple iPhone') {
    return { compatible: false, device: 'iPhone', message: strings.iphoneNotFound };
  }

  if (fullName.includes('iPhone')) {
    return { compatible: eSimCountUnknown || eSimCount >= 1, device: 'iPhone', message: '' };
  }

  if (fullName.includes('iPad')) {
    return { compatible: false, device: 'iPad', message: eSimCount == 0 ? '' : strings.ipadNotFound };
  }

  if (properties.osName == 'Android') {
    if (eSimCountUnknown) {
      message = strings.androidNotFound;
    } else if (eSimCount >= 1) {
      compatible = true;
    }
    return { compatible: compatible, device: device, message: message };
  }

  if (deviceInfo && deviceInfo.desktopIdentified === true) {
    return { compatible: false, device: 'Desktop', message: strings.desktopNotFound };
  }

  return { compatible: false, device: 'unknown device', message: strings.deviceNotFound };
}
